import '../../shared-chunks/debug-to-string-BsFOvUtQ.js';
import '@embroider/macros';
import '../../@glimmer/global-context/index.js';
import '../../@glimmer/destroyable/index.js';
import '../../@glimmer/validator/index.js';
import '../../shared-chunks/reference-B6HMX4y0.js';
import '../../shared-chunks/capabilities-DHiXCCuB.js';
import { s as setComponentManager$1 } from '../../shared-chunks/api-1B_9SjFR.js';
export { c as capabilities } from '../../shared-chunks/api-1B_9SjFR.js';
export { g as getComponentTemplate, s as setComponentTemplate } from '../../shared-chunks/template-CMHIG4cn.js';
import '../../shared-chunks/index-CQkjwqTv.js';
export { I as Input, T as Textarea, C as default } from '../../shared-chunks/index-Cn-XMJI4.js';
import '../../shared-chunks/registry-XY5cfmbH.js';
import '../debug/index.js';
import '../../shared-chunks/dynamic-CIt6-yIX.js';
import '../../shared-chunks/constants-oDhF27qL.js';
import '../runloop/index.js';

/**
   Associate a class with a component manager (an object that is responsible for
   coordinating the lifecycle events that occurs when invoking, rendering and
   re-rendering a component).

   @method setComponentManager
   @param {Function} factory a function to create the owner for an object
   @param {Object} obj the object to associate with the componetn manager
   @return {Object} the same object passed in
   @public
  */
function setComponentManager(manager, obj) {
  return setComponentManager$1(manager, obj);
}

export { setComponentManager };
